var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import mediaQueries from "syf-component-library/const/mediaQueries";
import { fontSizes } from "syf-component-library/defaultTheme";
import { H4 } from "syf-component-library/ui/typography";
var CreditAffectsTitle = styled(H4)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  @media ", " {\n    font-size: ", "px;\n  }\n"], ["\n  @media ", " {\n    font-size: ", "px;\n  }\n"])), mediaQueries.lessThanMedium, fontSizes.root);
export default CreditAffectsTitle;
var templateObject_1;
